import type { TypingStatusMessageWebSocket, TYPING_STATUS } from "../Models/WebSocket";
import type { ChatStore } from "../Store";
import { MessageTypeWebSocket } from "../Models/WebSocket";

class SendTextMessageActionHandler {
  constructor(private readonly chatStore: ChatStore) {}

  public async handle(chatId: string, status: TYPING_STATUS): Promise<TypingStatusMessageWebSocket> {
    return this.sendTextMessageActionHandler(chatId, status);
  }

  private async sendTextMessageActionHandler(
    chatId: string,
    status: TYPING_STATUS
  ): Promise<TypingStatusMessageWebSocket> {
    return new Promise<TypingStatusMessageWebSocket>((resolve) => {
      const statusEventPayload: TypingStatusMessageWebSocket = {
        chat: chatId,
        nonce: `${Date.now() + Math.floor(Math.random() * 1000)}`,
        status,
        type: MessageTypeWebSocket.STATUS,
      };

      this.chatStore.socketManager?.sendMessage(statusEventPayload);

      resolve(statusEventPayload);
    });
  }
}

export default SendTextMessageActionHandler;
